import * as v from 'valibot';
import { ROUTE_VARIANT_VALUES } from '~/core/types/RouteVariant';

// URN string, e.g. "urn:uic:stn:8507354"
export const PresetPlaceSchema = v.pipe(v.string(), v.regex(/^urn:uic:stn:\d{5,10}$/));

export const PresetListingSchema = v.string();

// Product key, e.g. "swa", "jtp", "joch-epr"
export const PresetUpsellSchema = v.pipe(v.string(), v.maxLength(100), v.regex(/^[a-z0-9-]+$/));

// UUID, e.g. "19fa6d77-9437-44a5-8c19-4184a16912b6"
export const PresetUuidSchema = v.pipe(v.string(), v.maxLength(100), v.regex(/^[a-z0-9-]+$/));

// Alphanumeric string
export const AlphanumericSchema = v.pipe(v.string(), v.maxLength(100), v.regex(/^[a-z0-9-]+$/));

// Reduction card schema, e.g. "JUNGFRAU_TRAVEL_PASS", "JB_SKI_PASS"
export const ReductionCardSchema = v.pipe(v.string(), v.maxLength(100), v.regex(/^[A-Z0-9_]+$/));

export const ProductConfigPresetSchemaP2P = v.object({
    origins: v.optional(v.pipe(v.array(PresetPlaceSchema), v.maxLength(20))),
    destinations: v.optional(v.pipe(v.array(PresetPlaceSchema), v.maxLength(20))),
    returnOrigins: v.optional(v.pipe(v.array(PresetPlaceSchema), v.maxLength(20))),
    returnDestinations: v.optional(v.pipe(v.array(PresetPlaceSchema), v.maxLength(20))),
    isRoundtrip: v.optional(v.union([v.boolean(), v.literal('optional')])),
    canSwitchDirection: v.optional(v.boolean()),
    canChooseReturnDestination: v.optional(v.boolean()),
    isUsingReductionCards: v.optional(v.boolean()),
    isUsingKeyCards: v.optional(v.boolean()),
    isUsingPromos: v.optional(v.boolean()),
    upsells: v.optional(v.pipe(v.array(PresetUpsellSchema), v.maxLength(20))),
    departureTimeIteration: v.optional(v.union([v.literal(30), v.literal(60)])),
    departureTimeDefaultMin: v.optional(v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(1440))),
    stayDurationIteration: v.optional(v.union([v.literal(30), v.literal(60)])),
    stayDurationPopular: v.optional(v.pipe(v.number(), v.integer(), v.minValue(0))),
    stayDurationMin: v.optional(v.pipe(v.number(), v.integer(), v.minValue(0))),
    maxNumberOfPeople: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
    maxNumberOfPeopleGroupTariff: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
    defaultPassengerAge: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(99))),
    hiddenProductReductionCard: v.optional(ReductionCardSchema),
    offerFlowContentId: v.optional(AlphanumericSchema),
    routeVariantUp: v.optional(v.picklist(ROUTE_VARIANT_VALUES)),
    routeVariantDown: v.optional(v.picklist(ROUTE_VARIANT_VALUES)),
    listingId: v.optional(PresetListingSchema),
});

export const ProductConfigPresetSchemaActivity = v.object({
    activityId: v.optional(PresetUuidSchema),
    isMultiDay: v.optional(v.boolean()),
    isUsingReductionCards: v.optional(v.boolean()),
    isUsingKeyCards: v.optional(v.boolean()),
    isUsingPromos: v.optional(v.boolean()),
    maxNumberOfPeople: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
    maxNumberOfPeopleGroupTariff: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
    defaultPassengerAge: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(99))),
    hiddenProductReductionCard: v.optional(ReductionCardSchema),
    upsells: v.optional(v.pipe(v.array(PresetUpsellSchema), v.maxLength(20))),
    offerFlowContentId: v.optional(AlphanumericSchema),
    listingId: v.optional(PresetListingSchema),
});

export type ProductConfigPresetSchema = typeof ProductConfigPresetSchemaP2P | typeof ProductConfigPresetSchemaActivity;
